import { Component, OnInit } from '@angular/core';
import {AppComponent} from '../../../app.component';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {UserService} from '../../../service/UserService';
import {DomSanitizer} from '@angular/platform-browser';
import {SafeResourceUrl} from '@angular/platform-browser/src/security/dom_sanitization_service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public urlBi: SafeResourceUrl;
  constructor(private app: AppComponent, private routeActivated: ActivatedRoute, private user: UserService, private dom: DomSanitizer) {
    routeActivated.params.subscribe((params: any) => {
      if(params && params.type == 'agent') {
        this.urlBi = dom.bypassSecurityTrustResourceUrl(environment.api.bi.agent.replace('__username__', user.getUser('userName')));
      }
      if(params && params.type == 'teams') {
        this.urlBi = dom.bypassSecurityTrustResourceUrl(environment.api.bi.teams.replace('__username__', user.getUser('userName')))
      }
      if(params && params.type == 'n1') {
        this.urlBi = dom.bypassSecurityTrustResourceUrl(environment.api.bi.n1.replace('__username__', user.getUser('userName')))
      }
    })
  }

  ngOnInit() {
    this.app.sidenav.toggle()
  }
  iframe(ev) {
    //$0.contentDocument.querySelector('.visual').remove()
    console.log('finish iframe:', ev)
  }
}



// WEBPACK FOOTER //
// ./src/app/view/bi/dashboard/dashboard.component.ts